import { render } from "./entities-menu.vue?vue&type=template&id=3f4cfa0e&ts=true"
import script from "./entities-menu.component.ts?vue&type=script&lang=ts"
export * from "./entities-menu.component.ts?vue&type=script&lang=ts"

import exportComponent from "/home/haris/IdeaProjects/bloodpressure/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__